import React, { type FunctionComponent } from 'react'
import { Button, type ButtonProps } from '@retailer-platform/shared-components/src/tds'
import { useDomainMessages } from '../../utils/domain/intl'
import {
  type SubmitFeedbackFlowProps,
  useSubmitFeedbackFlow,
} from '../use-submit-feedback-flow/useSubmitFeedbackFlow.hook'

export type SubmitFeedbackButtonProps = SubmitFeedbackFlowProps & {
  buttonProps?: ButtonProps
}

export const SubmitFeedbackButton: FunctionComponent<
  React.PropsWithChildren<SubmitFeedbackButtonProps>
> = props => {
  const { modal, openModal } = useSubmitFeedbackFlow(props)

  const i18n = useDomainMessages({
    submitFeedback: 'approvalManagementLibrary.actions.submitFeedback',
  })

  return (
    <>
      {modal}
      <Button name="addReview" onClick={openModal} {...(props.buttonProps || {})}>
        {i18n.submitFeedback}
      </Button>
    </>
  )
}
